import {
  createApiClient,
  isApiError,
  type RequestOptions,
  type BlobRequestOptions,
} from '@shigo-ui/api-client';
import type { z } from 'zod';
import { handleShigoRequestError } from './shigoQueryClient';

export type ShigoApiConfig = {
  apiBaseUrl: string;
  networkId: string;
};

export function createShigoApiClient(
  config: ShigoApiConfig,
  accessToken?: string,
  fetcher?: typeof fetch,
) {
  const headers = new Headers();

  if (config.networkId) {
    headers.set('networkId', config.networkId);
  }
  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }

  const client = createApiClient({
    baseUrl: config.apiBaseUrl,
    headers,
    ...(fetcher ? { fetcher } : {}),
  });

  async function requestWithLogout<T>(request: () => Promise<T>): Promise<T> {
    try {
      return await request();
    } catch (error) {
      if (accessToken && isApiError(error) && error.status === 401) {
        handleShigoRequestError(error, accessToken);
      }
      throw error;
    }
  }
  return {
    request: <TSchema extends z.ZodType>(options: RequestOptions<TSchema>) =>
      requestWithLogout(() => client.request(options)),
    requestBlob: (options: BlobRequestOptions) =>
      requestWithLogout(() => client.requestBlob(options)),
  };
}
